import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import Spinner from '../../../common/components/misc/Spinner';
import * as ApiHelperService from '../../../common/services/ApiHelper';
import { PrimeError } from '../../../common/types';
import { LoginWithGCDMResponseDTO } from '../../../common/types/dto/LoginWithGCDMResponseDTO';
import { config } from '../../common/';
import { AppThunkDispatch } from '../../common/types';

interface ReduxDispatchProps {
    apiHelper: ApiHelperService.ServiceActions;
}

interface MatchParams {
    formid: string;
    src: string;
    redirectParent: string;
}

type LoginWithGCDMProps = ReduxDispatchProps & RouteComponentProps<MatchParams>;

const LoginWithGCDM: React.FC<LoginWithGCDMProps> = (props) => {
    const { t } = useTranslation();
    const [isCommunicating, setIsCommunicating] = useState(false);
    const [isError, setIsError] = useState(false);

    const execute = async (): Promise<void> => {
        const formid = props.match.params.formid; // gup('formid');
        const src = props.match.params.src ? decodeURIComponent(props.match.params.src) : undefined; // gup('src');
        const redirectInParent = props.match.params.redirectParent === '1';
        // if (!src) {
        //    src = '/';
        // }

        setIsCommunicating(true);
        setIsError(false);
        await props.apiHelper.post(`/api/${config.ResourceCode}/auth/gcdm-login`, {
            formid,
            src,
            querystring: window.location.search,
        }, null, null).then((axiosResponse) => {
            const response = axiosResponse.data as LoginWithGCDMResponseDTO;
            if (response && response.redirectUrl) {
                if (redirectInParent === true) {
                    window.parent.location.href = response.redirectUrl;
                } else {
                    window.location.href = response.redirectUrl;
                }
            }
            setIsCommunicating(false);
        }).catch((error) => {
            console.log(error); // tslint:disable-line
            setIsCommunicating(false);
            setIsError(true);
        });
    };

    useEffect(() => {
        // first time execution
        execute();
    }, []);

    if (isCommunicating) {
        return (<Spinner />);
    } else if (isError) {
        throw new PrimeError(t(`auth:gcdm.errorHeader`), t(`auth:gcdm.errorDescription`).replace('{0}', config.BaseURL), false);
    } else {
        return (<Spinner />);
    }
};

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    apiHelper: ApiHelperService.bindServiceActionCreators(config, dispatch),
});

export default connect(null, mapDispatchToProps)(LoginWithGCDM);
